import { z } from 'zod';

import {
  CallType,
  CampaignAdvertiser,
  NonEmptyText,
  ProductType,
  SubProductType,
} from '../primitive';

export const PhoneCampaign = z.object({
  phoneNumber: NonEmptyText,
  todayTTY: z.string(),
  weekTTY: z.string(),
  tty: z.string(),
  schedule: z.string(),
  href: NonEmptyText,
  product: ProductType,
  subProduct: SubProductType.optional(),
  placement: NonEmptyText,
  advertiser: CampaignAdvertiser,
  callType: CallType,
});

// eslint-disable-next-line no-redeclare
export type PhoneCampaign = z.infer<typeof PhoneCampaign>;
